<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.template_source_entry_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.templateSourceEntryCreate"
    [queryParams]="{templateGroupID: templateSource?.templateGroup?.id, templateSourceID: templateSource?.id}"
    sbTooltip="{{ 'nav.templateSourceEntries.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>


<!------------------------------

    Table wrapper

------------------------------->
@let isExpanded = checkExpansion();
<sb-table-wrapper-new
  headline="{{'lang.globals.templateSourceEntries' | translate}}"
  [itemsData]="templateEntries"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'templateSourceEntries'">

  <!------------------------------

  Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >
      <div
        #filterPanelTimeRange
        class="tw-flex tw-flex-row tw-mx-3 tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit "
        [ngClass]="{'tw-cursor-pointer': !isExpanded}"
        (click)="!isExpanded?openFilterPanel(filterPanelTimeRange):scrollToFilterPanelElement(filterPanelTimeRange)">
        <sb-icon class="tw-text-xl" [ngClass]="{'tw-ml-2.5': !isExpanded}" icon="calendar"></sb-icon>
        <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
             [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.timeRange' | translate }}
        </div>
      </div>

      @if (isExpanded) {
        <sb-local-date-range-input
          class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-mx-3"
          [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-auto': isExpanded,
    }"
          [from]="from" [till]="till" [displayMonths]="1" [showSubmit]="true" [today]="null" [allowEmpty]="true"
          (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
      }
    </sb-filter-panel>
  </div>

  <!------------------------------

       Table Header

 ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.validity' | translate }}
      </th>
      @for (variable of templateSource?.templateGroup?.variables; track variable.name) {
        <th>
          Var: {{ variable.name }}
        </th>
      }
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

   Table Body

------------------------------->
  <ng-template #tbody let-data>
    <tr>
      <td>
        {{ data?.id }}
      </td>
      <td>
        <sb-comp-link
          [title]="data?.name"
          [permission]="permissionService.Permission.template_source_entry_create"
          [link]="util.RoutingID.templateSourceEntryEdit"
          [queryParams]="{templateGroupID: templateSource?.templateGroup?.id, templateSourceID: templateSource?.id}"
          [pathParams]="[{id: 'templateSourceEntryID',value: data?.id}]"
          [tooltip]="'lang.globals.edit' | translate">
        </sb-comp-link>
      </td>
      <td>
        @if (data?.validFrom && data?.validTill) {
          <div>
            {{ data?.validFrom?.toString() | date: 'dd.MM.yyyy' }} - {{ data?.validTill?.toString() | date: 'dd.MM.yyyy' }}
          </div>
        } @else if (!data?.validFrom && data?.validTill) {
          <div>
            {{ 'lang.template.till' | translate }}{{ data?.validTill?.toString() | date: 'dd.MM.yyyy' }}
          </div>
        } @else if (data?.validFrom && !data?.validTill) {
          <div>
            {{ 'lang.template.from' | translate }}{{ data?.validFrom?.toString() | date: 'dd.MM.yyyy' }}
          </div>
        } @else {
          <div>
            {{ 'lang.globals.indefinitelyValid' | translate }}
          </div>
        }
      </td>
      @for (variable of templateSource?.templateGroup?.variables; track variable.name) {
        <td>
          @if (data?.values[variable.name]) {
            @if (variable.type === TemplateVariableType.TEXT) {
              <div>
                <span [innerHTML]="data?.values[variable.name] | truncate: 100"></span>
              </div>
            } @else if (variable.type === TemplateVariableType.IMAGE) {
              <div>
                <img class="symbol-label" [src]="data?.values[variable.name]" alt="{{variable.name}}" loading="lazy">
              </div>
            }
          } @else {
            <span style="font-style: italic; opacity: 0.3">n. def.</span>
          }
        </td>
      }
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="data.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(data, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>
